// extracted by mini-css-extract-plugin
export var centerText = "_cc-8";
export var container = "_cc-0";
export var doughnutContainer = "_cc-7";
export var legend = "_cc-a";
export var legendItemColorDisplay = "_cc-b";
export var legendItemLabel = "_cc-d";
export var legendItemValue = "_cc-c";
export var lg = "_cc-5";
export var maxWidth = "_cc-9";
export var md = "_cc-4";
export var responsive = "_cc-6";
export var sm = "_cc-3";
export var xs = "_cc-2";
export var xxs = "_cc-1";